module.exports = __webpack_public_path__ + "img/img_02.b6661c85.png";